import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2.4",
      d: "M24 16c9.941 0 18-2.686 18-6s-8.059-6-18-6S6 6.686 6 10s8.059 6 18 6"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2.4",
      d: "M6 10v28c0 1.591 1.896 3.117 5.272 4.243C14.648 43.368 19.226 44 24 44s9.352-.632 12.728-1.757S42 39.59 42 38V10"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2.4",
      d: "M6 24c0 1.591 1.896 3.117 5.272 4.243C14.648 29.368 19.226 30 24 30s9.352-.632 12.728-1.757S42 25.59 42 24"
    }, null, -1)
  ]))]))
}
export default { render: render }